import { h, Fragment, createContext } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { InstallAd } from '../installAd/InstallAd';
import { DetectBrowser } from '../utils/DetectBrowser';
import { ExtensionUtil } from '../utils/ExtensionUtil';

export const BrowseContext = createContext({
  isInstalled: "none",
  showAd: false,
  browserName: "",
  platform: "",
  isBrowserSupported: false,
  browserStoreText: "",
  browserStoreImage: "",
  adSource: "browse.live",
  adMedium: "organic",
  adCampaign: "serp"
});

export const BrowseContextProvider = (props) => {
    const [isInstalledState, setIsInstalledState] = useState("none");
    const [showAd, setShowAd] = useState(false);
    const browserName = DetectBrowser.getBrowserName();
    const isBrowserSupported = DetectBrowser.isBrowserSupported(browserName);
    const browserStoreText = ExtensionUtil.GetBrowserStoreText(browserName);
    const browserStoreImage = ExtensionUtil.GetBrowserStoreImage(browserName);
    const platform = DetectBrowser.getPlatformType();
    const adCampaign = props.adCampaign ? props.adCampaign : "serp";
    let broadcastCh = null;
    try {
      if(typeof(BroadcastChannel) != "undefined" && BroadcastChannel) {
        broadcastCh = new BroadcastChannel('browsecontextprovider_channel');
        broadcastCh.onmessage = (evt) => {
          if(evt && evt.data && evt.data.type === "closeAd") {
            setShowAd(false);
          }
        }
      }
    } catch(ex) {
      //do nothing
    }

    const setStateVars = (isInstalled) => {
      setIsInstalledState(isInstalled === true ? "yes" : "no");
      let tShowAd = false;
      if(isInstalled === false) {
        let adClosedOn = window.localStorage.getItem("adClosedOn")
        if(adClosedOn) {
          let intAdClosedOn = parseInt(adClosedOn);
          if((Date.now() - intAdClosedOn) > (1000*60*60*1)) { //dont show it for 1 hr
            window.localStorage.removeItem("adClosedOn")
            tShowAd = true;
          }
        } else {
          tShowAd = true;
        }
      }
      setShowAd(tShowAd);
    }
    const checkDelta = 200; //every 200ms
    let setTimeoutTimer = null;
    const setInstallationStatus = (cnt=1) => {
      ExtensionUtil.isWebSafetyInstalled().then(resp => {
        if(resp !== undefined && resp !== null && resp !== "") {
          setStateVars(resp);
        } else {
            // trying to get installation status again
          tryGetInstallationStatus(cnt);
        }
      },).catch(() => {
        tryGetInstallationStatus(cnt);
      })
    }
    const tryGetInstallationStatus = (cnt=0) => {
      if(cnt > 5) {
        setStateVars(false);
        return; //almost waited for 8 seconds to find it out
      }
      setTimeoutTimer = setTimeout(() => {
        setInstallationStatus(cnt+1)
      }, checkDelta);
    }
       
    useEffect(() => {
        if(isBrowserSupported) {
          try {
            setInstallationStatus();
          } catch(ex) {
            //do nothing here
          }
          //try setting search info to extension if installed
          try {
            ExtensionUtil.SetSearchSetting();
          } catch(ex) {
          }
          document.addEventListener('aeBlurWidgetParamsUpdate', (e) => {
              setTimeout(ExtensionUtil.SetSearchSetting, 500);
          });

            return (() => {
              clearTimeout(setTimeoutTimer);
            })
        }
    }, []);
    const hideAd = () => {
      try {
        window.localStorage.setItem('adClosedOn', Date.now());
        if(broadcastCh) {
          broadcastCh.postMessage({type: "closeAd"});
        } else {
          setShowAd(false);
        }
      } catch(ex) {
        //do nothing here
      }
    }
    return (
        <BrowseContext.Provider value={{
            isInstalled: isInstalledState, 
            showAd: showAd,
            browserName: browserName,
            platform: platform,
            isBrowserSupported: isBrowserSupported,
            browserStoreText: browserStoreText,
            browserStoreImage: browserStoreImage,
            adSource: "browse.live",
            adMedium: "organic",
            adCampaign: adCampaign,
            hideAd: hideAd,
        }}>
          <div style={showAd ? { background: "var(--darkBgColor)", position: "fixed", width: "100vw", left: "0", top: "0",color: "var(--bgLightGray)", fontSize: "0.8em",zIndex: "9999999"} : {display: "none"}}>
              <InstallAd />
          </div>
          <div style={showAd ? {marginTop: "30px"} : {}}>
              {props.children}
          </div>
      </BrowseContext.Provider>
    )
  }